import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "lock-designer-panel" }
const _hoisted_2 = { class: "lock-designer-content" }
const _hoisted_3 = { class: "lock-designer-panel__content" }
const _hoisted_4 = { class: "lock-designer-panel__content-header" }
const _hoisted_5 = { class: "lock-designer-panel__content-body" }
const _hoisted_6 = { class: "lock-designer-panel__content-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LockDesignerPanelHeader = _resolveComponent("LockDesignerPanelHeader")
  const _component_ComponentGroup = _resolveComponent("ComponentGroup")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LockDesignerPanelHeader, {
      backToRoute: _ctx.backToRoute,
      onUpdateRouteBack: $options.handleBackClick
    }, null, 8 /* PROPS */, ["backToRoute", "onUpdateRouteBack"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentGroups, (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (group.isHeader)
                ? (_openBlock(), _createBlock(_component_ComponentGroup, _mergeProps({ key: 0 }, group, {
                    onUpdateSelection: $options.handleUpdateSelection,
                    onUpdateRoute: $options.handleUpdateRoute,
                    onUpdateRouteBack: $options.handleBackClick
                  }), null, 16 /* FULL_PROPS */, ["onUpdateSelection", "onUpdateRoute", "onUpdateRouteBack"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentGroups, (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (!group.isFooter && !group.isHeader)
                ? (_openBlock(), _createBlock(_component_ComponentGroup, _mergeProps({ key: 0 }, group, {
                    onUpdateSelection: $options.handleUpdateSelection,
                    onUpdateRoute: $options.handleUpdateRoute,
                    onUpdateRouteBack: $options.handleBackClick
                  }), null, 16 /* FULL_PROPS */, ["onUpdateSelection", "onUpdateRoute", "onUpdateRouteBack"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentGroups, (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (group.isFooter)
                ? (_openBlock(), _createBlock(_component_ComponentGroup, _mergeProps({ key: 0 }, group, {
                    onUpdateSelection: $options.handleUpdateSelection,
                    onUpdateRoute: $options.handleUpdateRoute,
                    onUpdateRouteBack: $options.handleBackClick
                  }), null, 16 /* FULL_PROPS */, ["onUpdateSelection", "onUpdateRoute", "onUpdateRouteBack"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}